import React, {useState} from 'react'
import {warehouseReports} from "../../services/serviceReports";
import {Card, Col, Row, Space, Table} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import Filter from "../filterWrapper/Filter";
import WarehouseReportsFilter from "./WarehouseReportsFilter";
import PieChart from "../charts/PieChart";


const setTableRowKeys = (r, index) => index

const WarehouseReports = () => {
    const [tableData, setTableData] = useState([])
    const [openFilter, setOpenFilter] = useState(false)
    const [chartData, setChartData] = useState({})

    const clearTable = () => setTableData([])

    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    const columns = [
        {title: 'Depo', dataIndex: 'warehouseName'},
        {title: 'Adet', dataIndex: 'quantity', render: (t, r) => <p>{new Intl.NumberFormat().format(t)} <span className={'font-bold'}>{r.currency}</span></p>}
    ]

    const handleFilter = (...filterData) => {
        warehouseReports(filterData[0])
            .then(({data}) => {
                prepareChartData(data)
                setTableData(data)
            })
        return new Promise((resolve, reject) => {
            resolve(true)
            reject(false)
        })
    }

    const prepareChartData = (data) => {
        const chartObj = {}
        data.map(warehouseObj => {
            const warehouseName = warehouseObj.warehouseName.toLocaleLowerCase()
            if (chartObj.hasOwnProperty(warehouseName) && warehouseObj.quantity > 0) {
                chartObj[warehouseName].values.push(warehouseObj.quantity)
                chartObj[warehouseName].currencies.push(warehouseObj.currency)
            } else if (!chartObj.hasOwnProperty(warehouseName) && warehouseObj.quantity > 0) {
                chartObj[warehouseName] = {}
                chartObj[warehouseName].values = []
                chartObj[warehouseName].currencies = []
                chartObj[warehouseName].values.push(warehouseObj.quantity)
                chartObj[warehouseName].currencies.push(warehouseObj.currency)
            }
        })

        setChartData(chartObj)
    }


    return(
        <React.Fragment>
            <Card
                title={'Depo Raporları'}
            >
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Row justify={"start"}>
                        <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                    </Row>
                    {
                        tableData.length ?
                            <Row gutter={32}>
                                {
                                    Object.keys(chartData).map(key => {
                                        const item = chartData[key]
                                        if (item.currencies.length && item.values.length) {
                                            return (
                                                <Col span={8}>
                                                    <h5 style={{textTransform: 'capitalize'}}>{key}</h5>
                                                    <PieChart
                                                        xAxis={item.currencies}
                                                        yAxis={item.values}
                                                    />
                                                </Col>
                                            )
                                        }
                                    })
                                }
                            </Row>
                            : null
                    }
                    <Table rowKey={setTableRowKeys} columns={columns} dataSource={tableData}/>
                </Space>
            </Card>

            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Depo Raporlama'}
                    handler={handleFilter}
                    resetHandler={clearTable}
                >
                    <WarehouseReportsFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default WarehouseReports